var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pdfView",staticClass:"pdf_view",on:{"scroll":_vm.pdfScroll}})
}
var staticRenderFns = []

export { render, staticRenderFns }